import { createGlobalStyle } from "styled-components";

export const GlobalListStyles = createGlobalStyle`
  html {
    overflow: hidden;
  }
`;